import React, { useState } from 'react';
import type { AvailableRequestForm } from '@this/src/domain/available_request_form';
import _ from 'lodash';

type Props = {
  currentRequestForms: AvailableRequestForm[];
};

type CategoryType = AvailableRequestForm;
type CategoryGroupType = 'hotel' | 'flight' | 'railway' | 'rentalcar' | 'other';
type State = CategoryType[];

type CategoryGroupProps = {
  label: string;
  categories: CategoryType[];
};

const CATEGORY_DISPLAY_NAME: { [key in CategoryType]: string } = {
  hotel: 'ホテル',
  foreign_flight: '海外航空券',
  domestic_flight: '国内航空券',
  shinkansen: '新幹線',
  rentalcar: 'レンタカーフォーム',
  other: 'その他の商材'
};
const CATEGORY_GROUP_DISPLAY_NAME: { [key in CategoryGroupType]: CategoryGroupProps } = {
  hotel: {
    label: 'ホテル',
    categories: ['hotel']
  },
  flight: {
    label: '航空券',
    categories: ['domestic_flight', 'foreign_flight']
  },
  railway: {
    label: '鉄道',
    categories: ['shinkansen']
  },
  rentalcar: {
    label: 'レンタカー',
    categories: ['rentalcar']
  },
  other: {
    label: 'その他の商材',
    categories: ['other']
  }
};

const isChecked = (state: State, category: CategoryType) => state.includes(category);

const AvailableRequestFormsForm: React.FC<Props> = ({ currentRequestForms }) => {
  const [state] = useState<State>(currentRequestForms);

  return (
    <div style={{ paddingLeft: '10px' }}>
      {Object.entries(CATEGORY_GROUP_DISPLAY_NAME).map(([group, { label, categories }], index) => (
        <div key={group} style={{ display: 'flex', alignItems: 'center', marginTop: index > 0 ? '10px' : '0' }}>
          <label style={{ width: '160px' }}>{label}:</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {categories.map(category => (
              <label key={category} style={{ display: 'flex', alignItems: 'center' }}>
                <input type="checkbox" value={category} checked={isChecked(state, category)} disabled />
                <span>{CATEGORY_DISPLAY_NAME[category]}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AvailableRequestFormsForm;
